import createBrowserHistory from 'history/createBrowserHistory';

const historyInstance = createBrowserHistory();

export default historyInstance;
